import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { useState } from "react";
import { Button } from "@/components/ui/button";
import { ArrowLeftRight } from "lucide-react";
import { PageHeader } from "@/components/ds";
import { ManualMovementModal } from "@/components/ds/ManualMovementModal";
import { MaterialsPanel } from "@/components/ds/MaterialsPanel";
import { FinishedGoodsPanel } from "@/components/ds/FinishedGoodsPanel";
import Filaments from "@/pages/Filaments";

export default function Stock() {
  const [moving, setMoving] = useState(false);
  return (
    <div className="space-y-8" data-testid="stock-page">
      <PageHeader
        title="Estoque"
        subtitle="Tudo o que a TR3ND STUDIO guarda: filamentos em gramas, materiais e insumos na unidade de cada item e os produtos acabados prontos para vender."
        action={
          <Button
            onClick={() => setMoving(true)}
            data-testid="open-manual-movement-btn"
            className="h-11 rounded-full px-5 font-semibold"
          >
            <ArrowLeftRight className="mr-2 h-4 w-4" /> Movimentar estoque
          </Button>
        }
      />
      <Tabs defaultValue="filamentos">
        <TabsList className="bg-secondary/60">
          <TabsTrigger value="filamentos" data-testid="tab-stock-filaments">
            Filamentos
          </TabsTrigger>
          <TabsTrigger value="materiais" data-testid="tab-stock-materials">
            Materiais e insumos
          </TabsTrigger>
          <TabsTrigger value="acabados" data-testid="tab-stock-finished">
            Produtos acabados
          </TabsTrigger>
        </TabsList>

        <TabsContent value="filamentos" className="mt-6">
          <Filaments embedded />
        </TabsContent>
        <TabsContent value="materiais" className="mt-6">
          <MaterialsPanel />
        </TabsContent>
        <TabsContent value="acabados" className="mt-6">
          <FinishedGoodsPanel />
        </TabsContent>
      </Tabs>

      {moving && (
        <ManualMovementModal
          onClose={() => setMoving(false)}
          onSaved={() => window.location.reload()}
        />
      )}
    </div>
  );
}
